import { render } from "./CreateIsolatedNetworkForm.vue?vue&type=template&id=35aa3978&scoped=true"
import script from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateIsolatedNetworkForm.vue?vue&type=style&index=0&id=35aa3978&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aa3978"]])

export default __exports__